module.exports = __webpack_public_path__ + "media/4x3/bl-38e27b68.svg";